import * as React from 'react';

import ProductSpecFeature from './Feature';
import { FeatureGroup } from './types';

export interface ProductSpecFeatureGroupProps {
	uniqueId: string;
	featureGroup: FeatureGroup;
}

export const ProductSpecFeatureGroup: React.FC<ProductSpecFeatureGroupProps> = ({
	uniqueId,
	featureGroup,
}) => {
	return (
		<div>
			<h4 className="text-title">{featureGroup.featureGroupName}</h4>

			<table className="w-full mb-4">
				<tbody>
					{featureGroup.features.map((feature, featureIdx) => (
						<ProductSpecFeature
							key={`${featureGroup.featureGroupName}-${feature.featureName}`}
							className={featureIdx % 2 === 0 ? 'bg-gray-10' : ''}
							tooltipId={`${feature.featureName}-${uniqueId}`}
							feature={feature}
						/>
					))}
				</tbody>
			</table>
		</div>
	);
};

export default ProductSpecFeatureGroup;
